export default __webpack_public_path__ + "static/media/19g30mmsb.93a3bd3f.jpeg";